export default __webpack_public_path__ + "static/media/app_icon.2b179fb7.svg";